import { Box } from '@chakra-ui/react'

import { AppLoading } from '@/components/AppLoading'
import { LoadingFailedAlert } from '@/components/LoadingFailedAlert'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { MeetingRecordProvider } from '@/context/MeetingRecordProvider'
import OffersAddonProvider from '@/context/OffersAddonProvider'
import { SelectedOffersAddonProvider } from '@/context/SelectedOffersAddonProvider'
import { SelectedQuoteProvider } from '@/context/SelectedQuoteContext'
import { useEffect, useState } from 'react'
import { Steps } from '../../../components/Steps/Steps'
import { WizzardHeader } from '../../../components/WizzardHeader/WizzardHeader'
import { StepComplete } from '../../../containers/steps/vehicle/StepComplete'
import { SidebarProvider } from '../../../context/SidebarContext'
import { StepsProvider } from '../../../context/StepsContext'
import { WizzardHeaderProvider } from '../../../context/WizzardHeaderContext'
import { PageWrapper } from '../../../layouts/components/PageWrapper'
import { Sidebar } from '../../../layouts/components/Sidebar'

export const StepCompletePage = () => {
  return (
    <StepsProvider currentStepId={4}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <StepCompleteContent />
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

const StepCompleteContent = () => {
  const { isLoadingData, insuranceParams, insuranceParamsId, error } = useInsuranceParams()

  const [calculationState] = useState({
    isCalculated: false,
    isCalculating: false,
  })

  useEffect(() => { }, [calculationState.isCalculated])

  return (
    <>
      {isLoadingData && <AppLoading />}

      {!isLoadingData && error && <LoadingFailedAlert />}

      {!isLoadingData && !!insuranceParams && !error &&
        <SelectedQuoteProvider >
          <OffersAddonProvider>
            <SelectedOffersAddonProvider>
              <MeetingRecordProvider insuranceParamsId={insuranceParamsId!}>
                <PageWrapper
                  steps={<Steps />}
                  header={<WizzardHeader />}
                  sidebar={<Sidebar />}
                  contentProps={{
                    sx: {
                      pt: { base: 0, md: 0 },
                    },
                  }}
                >
                  <Box sx={{ pt: { base: 0, md: 8 } }}>
                    <StepComplete />
                  </Box>
                </PageWrapper>
              </MeetingRecordProvider>
            </SelectedOffersAddonProvider>
          </OffersAddonProvider>
        </SelectedQuoteProvider>
      }
    </>
  )
}
